module.exports = __webpack_public_path__ + "img/64.97203415.jpg";